export default "__VITE_ASSET__a4958907__"